import store from "store";
import http from "./httpService";

const STORE_KEY_REPLIES = "quick-replies";

export default {
    pull() {
        let target = store.get(STORE_KEY_REPLIES);
        if (target) {
            target = Array.from(target);
            if (target.length > 0) {
                return http.post("/options/quick-replies", {
                    content: target
                }).then((data) => {
                    store.remove(STORE_KEY_REPLIES);
                    return http.get("/options/quick-replies");
                }, () => {
                    return target.map((item) => {
                        return {
                            content: item,
                            id: 0,
                            user_id: 0,
                        }
                    });
                });
            }
        }

        return http.get("/options/quick-replies");
    },
    push(text) {
        return http.post("/options/quick-replies", {
            content: text
        })
    },
    save(target) {
        const list = Array.from(target);
        store.set(STORE_KEY_REPLIES, list);
        return list;
    },
    remove(id) {
        return http.post(`/options/quick-replies/${id}/remove`)
    },
    share(id) {
        return http.post(`/options/quick-replies/${id}/share`)
    }
}
